import React, { useState } from "react";
import HeaderBar from "../../Components/UI/headerbar";
import DataTable from "../../Components/UI/table/DataTable";
import TableActions from "../../Components/UI/table/TableActions";
import FilterBar from "../../Components/UI/filterbar";

import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  deleteOrders,
  getOrders,
  getOrdersStats,
  showOrders,
} from "../../MyApi/orders";
import LoadingSpinner from "../../Components/UI/spinner";
import StatusBadge from "../../Components/orders/show/statusbadge";
import { formatPrice } from "../../utils/formatPrice";
import { useNavigate } from "react-router-dom";

import StatsCard from "../../Components/UI/staticsCard";
import ClockIcon from "../../Components/Common/svg/reports/clockicon";
import DollarSignIcon from "../../Components/Common/svg/reports/dollarsign";
import CancelIcon from "../../Components/Common/svg/reports/cancelicon";
import ShoppingIcon from "../../Components/Common/svg/shoppingicon";

const OrdersPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    date: "",
    from:"",
    to:"",
  });
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const deleteMutation = useMutation({
    mutationKey: ["postDelete"],
    mutationFn: (id) => deleteOrders(id),
  });

  const { data, isLoading, refetch, isFetching, error } = useQuery(
    ["getOrders", currentPage, filters],
    () => getOrders("", "", currentPage, false, filters),
    {
      keepPreviousData: true,
    },
  );

  const { data: statsOrderData, isLoading: isLoadingOrderStats } = useQuery(
    "getOrdersStats",
    getOrdersStats,
  );
  const orders = data?.data?.orders || [];
  const prefetchOrder = (id) => {
    queryClient.prefetchQuery(["showorders", id], () => showOrders(id), {
      staleTime: 1000 * 60 * 5, // 5 minutes
    });
  };

  const showorderPage = (id) => {
    navigate(`${process.env.PUBLIC_URL}/orders/${id}`);
    prefetchOrder(id);
  };

  const handledelete = (id) => {
    deleteMutation.mutate(id);
  };
  const ordersColumns = [
    {
      label: "معرف الطلب",
      render: (row) => <div className="text-green"> {row.id} </div>,
    },
    { label: "المتجر", render: (row) => ( <div>  {row?.store?.name ?? "___"}</div>) },
    { label: "العميل", accessor: "user.name" },
    {
      label: "المبلغ المستحق",
      render: (row) => (
        <div>
          {" "}
          {formatPrice(row.pricing.currency_factor, row.pricing.final_amount)}
        </div>
      ),
    },

    { label: "السائق", render: (row) => ( <div>  {row?.courier?.name ?? "___"}</div>) },
    {
      label: "الحالة",
      render: (row) => <StatusBadge status={row?.status?.value} />,
    },
    { label: "التاريخ   ", accessor: "created_at" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => showorderPage(row.id)}
          deleteAction={() => handledelete(row.id)}
          viewPermission={"view_order"}
        />
      ),
    },
  ];

  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;
  const orderStats = statsOrderData?.data || {};

  const StatsOrderConfig = [
    {
      title: "إجمالي الطلبات",
      count: orderStats.total,
      color: "#FFCC03",
      icon: <ShoppingIcon />,
      bgIcon: "#E6F3EF",
    },
    {
      title: "قيد الانتظار",

      count: orderStats.pending,
      color: "#3F5568",
      icon: <ClockIcon />,
      bgIcon: "#E7EAEC",
    },

    {
      title: " تم التوصيل",
      count: orderStats.delivered,
      color: "#1DBF73",
      icon: <DollarSignIcon />,
      bgIcon: "#F0FDF9",
    },
    {
      title: "تم الإلغاء",
      count: orderStats.cancelled,
      color: "#FF3B30",
      icon: <CancelIcon />,
      bgIcon: "#FDEAE9",
    },
  ];

  const filtersConfig = {
    search: "search",
    order_status: "order_status",
    date_range: "date_range",
  };

  const handleFilterChange = (newFilters) => {
    setCurrentPage(1); // Reset to first page when filters change
  };

  return (
    <div>
      <HeaderBar title={"إدارة الطلبات"} content={"تتبع وإدارة جميع الطلبات"} />

      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig}
        onFilterChange={handleFilterChange}
        placeholder="البحث باسم العميل أو معرف الطلب..."
      />

      <div className="row">
        {StatsOrderConfig.map((status, i) => (
          <div className="col-md-3" key={i}>
            <StatsCard {...status} isLoading={isLoadingOrderStats} />
          </div>
        ))}
      </div>

      <DataTable
        title={"إدارة الطلبات"}
        columns={ordersColumns}
        data={orders || []}
        refetch={refetch}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        onRetry={() => refetch()}
      />
    </div>
  );
};

export default OrdersPage;
